/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect } from 'react'
import Image from 'next/image'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { fastagBalanceService } from '@services/fastagBalanceService'
import { fetchDeepLink } from '@services/fastagAppflyer'
import CreateLead from '@services/createLead'
import assetLoader from '@utils/internalImageLoader'
import styles2 from './fastagModal.module.scss'
import styles from './showFastagDetails.module.scss'
import FastagDetails from './fastagDetails'
import {
  FEATURE_CONFIG,
  CROSS_ICON,
  CROSS_ICON_TEXT,
  DOWNLOAD_BTN_TEXT,
  FASTAG_CAR_IMG_TEXT,
  PRODUCT_NAME,
  SCAN_TO_DOWNLOAD,
  SCANNER_IMG,
  SCANNER_TEXT,
  TAP_BTN_ACKO_APP,
  FASTAG_CAR_IMG_2,
  TRY_AGAIN,
  FALLBACK_SOURCE_NAME,
  FALLBACK_PRODUCT_KEY,
  FALLBACK_API_KEY,
} from './constants'

const showFastagDetails = ({
  setShowFastagDetails,
  onModalClose,
  selectedBank,
  setSelectedBank,
  regNo,
  autoData,
  segmentEventCommonProperties,
  keyFeatures,
  noFastagFound,
  setNoFastagFound,
  phone,
  fastagData,
  setFastagData,
}) => {
  useEffect(() => {
    const fetchData = async () => {
      const data = await fastagBalanceService(regNo, selectedBank)
      if (data === null) {
        setNoFastagFound(true)
        return
      }
      setFastagData(data)
    }
    fetchData()
    CreateLead({
      registrationNumber: regNo,
      phoneNo: phone || '-',
      productKey: FALLBACK_PRODUCT_KEY,
      sourceName: FALLBACK_SOURCE_NAME,
      apiKey: FALLBACK_API_KEY,
    })
  }, [])

  const onDownloadApp = () => {
    trackEvent(TAP_BTN_ACKO_APP, {
      ...segmentEventCommonProperties,
      product: PRODUCT_NAME,
      registration_number: regNo,
    })

    fetchDeepLink(regNo)
  }

  const {
    balance = '',
    biller_details: billerDetails = '',
    biller_user_account: billerUserAccount = '',
    meta_data: metaData = '',
  } = fastagData

  const { db_make_name: dbMakeName = '', db_model_name: dbModalName = '' } = autoData
  return (
    <div className={styles.fastagDetailsWrapper}>
      <div className={styles.closeBtn} onClick={onModalClose}>
        <Image src={`${assetLoader()}${CROSS_ICON}`} alt={CROSS_ICON_TEXT} width={20} height={20} />
      </div>
      <div className={styles.fastagDetailContainer}>
        <div className={styles.allDetails}>
          <div className={styles.fastagVehicleDetailsWrapper}>
            <div className={styles.fastagFlex}>
              <div className={styles2.fastagVehicleDetailsFlex}>
                <div className={styles2.vehicleModal}>
                  <p>
                    {dbMakeName} {dbModalName}
                  </p>
                  <span>{regNo}</span>
                </div>
              </div>
              <Image
                width={162}
                height={75}
                layout="fixed"
                className={styles.carImg}
                src={FASTAG_CAR_IMG_2}
                alt={FASTAG_CAR_IMG_TEXT}
              />
            </div>
          </div>
          <FastagDetails
            noFastagFound={noFastagFound}
            balance={balance}
            metaData={metaData}
            billerUserAccount={billerUserAccount}
            billerDetails={billerDetails}
          />
        </div>
        {noFastagFound ? (
          <div>
            <button
              className={styles.btnTryAgain}
              type="button"
              onClick={() => {
                setShowFastagDetails(false)
                setSelectedBank(null)
              }}>
              {TRY_AGAIN}
            </button>
          </div>
        ) : (
          <div className={styles.banner}>
            <div className={styles.bannerHeading}>
              <h1>{keyFeatures[0]?.keyFeatureHighlight || FEATURE_CONFIG?.bannerHeading}</h1>
              <span>{keyFeatures[1]?.keyFeatureHighlight || FEATURE_CONFIG?.bannerSubheading}</span>
            </div>
            <div className={styles.bannerContent}>
              <div className={styles.bannerBulletPoints}>
                {FEATURE_CONFIG?.keyFeatures?.map(item => (
                  <div>
                    <span>
                      <Image src={item?.icon} alt={item?.alt} width={24} height={24} layout="fixed" />
                    </span>
                    {keyFeatures[item?.index]?.keyFeatureHighlight || item?.text}
                  </div>
                ))}
              </div>
              <div className={styles.downloadScannerContainer}>
                <div className={styles.downloadScanner}>
                  <Image
                    src={`${assetLoader()}${SCANNER_IMG}`}
                    className={styles.scannerImg}
                    width={100}
                    height={100}
                    alt={SCANNER_TEXT}
                  />
                  <span>{SCAN_TO_DOWNLOAD}</span>
                </div>
              </div>
              <div className={styles.downloadApp}>
                <button type="submit" onClick={() => onDownloadApp()}>
                  {DOWNLOAD_BTN_TEXT}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default showFastagDetails
